import { InputFormTypeRadio } from "../../mod.ts";
import { InputFormTypeAllType } from "../../../types.ts";
import { RadioInlineItemType } from "@config/app/questionTemplates/types.ts";

export const RadioInlineNeedComplementaryIncome = (
  {
    value,
    data: {
      id,
      label,
      required,
      disabled,
      reference,
      content: {
        choices,
      },
    },
    onError,
    onSuccess,
    lastCheckedAt = 0,
  }:
    & InputFormTypeAllType<{
      data: RadioInlineItemType;
    }>
    & {
      value?: string;
    },
) => {
  return (
    <InputFormTypeRadio
      onSuccess={onSuccess}
      onError={onError}
      id={id}
      legend={label}
      name={reference}
      fields={choices}
      value={value}
      isRequired={required}
      isDisabled={disabled}
      lastCheckedAt={lastCheckedAt}
    />
  );
};
